import Big from 'big.js';
import { CURRENCY_DIGITS } from './currency-data';

export enum Currency {
  Gbp = 'GBP',
  Eur = 'EUR',
  Clp = 'CLP',
}

export const convertToMajorUnits = (currency: string, amount: number): number => {
  const currencyInfo = CURRENCY_DIGITS[currency];
  if (currencyInfo === undefined) {
  throw new Error(`Currency code ${currency} not found`);
  }
  const divisor = new Big(10).pow(currencyInfo);
  return Number(new Big(amount).div(divisor));
};

export const formatMinorToMajor = (
  price: number,
  locale: string = 'en-GB',
  currency: string = Currency.Gbp
): string => {
  return Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    currencyDisplay: 'narrowSymbol',
  }).format(convertToMajorUnits(currency, price));
};

export const getCurrencySymbol = (currency: string, locale: string = 'en-GB') => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
    .formatToParts(0)
    .find((part) => part.type === 'currency')?.value;
};

export const formatMinorToMajorPercentage = (value: number, locale: string = 'en-GB'): string => {
  const majorPercentageValue = new Big(value).div(100);

  const hasDecimals = Number(majorPercentageValue.mod(10)) !== 0;
  const decimalPlaces = hasDecimals ? 1 : 0;

  const decimalPercentage = majorPercentageValue.div(1000);

  return Intl.NumberFormat(locale, {
    style: 'percent',
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  }).format(Number(decimalPercentage));
};
